<nav>
  @for (item of menuItems(); track item.route) {
    <a
      [routerLink]="item.route"
      routerLinkActive="active"
    >
      <img [src]="item.icon" [alt]="item.label" width="24" height="24" />
      <span>{{ item.label }}</span>
    </a>
  }
</nav>
